module.exports = __webpack_public_path__ + "static/media/Logo_full_blue.358059e9.svg";